export default "__VITE_ASSET__Im8RQmlv__"